import { PinnedJournalModel } from "./pinned-journal-model";

export interface UnpinnedJournalModel {
  id: string;
  styleId?: number;
  entryText?: string;
  isImportant?: boolean;
}
